"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var debounce_1 = tslib_1.__importDefault(require("lodash/debounce"));
var react_1 = require("react");
var getWindowDimensions = function () {
    var width = window.innerWidth, height = window.innerHeight;
    return {
        width: width,
        height: height,
        isXXS: width <= 400 ? true : false
    };
};
var UseWindowDimensions = function () {
    var _a = react_1.useState(getWindowDimensions()), windowDimensions = _a[0], setWindowDimensions = _a[1];
    react_1.useEffect(function () {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        window.addEventListener('resize', debounce_1.default(function () { return handleResize; }, 2000));
        return function () {
            return window.removeEventListener('resize', debounce_1.default(function () { return handleResize; }, 2000));
        };
    }, []);
    return windowDimensions;
};
exports.default = UseWindowDimensions;
//# sourceMappingURL=UseWindowDimension.js.map